export default __webpack_public_path__ + "static/Artificial_Light_Indoor_640kbps-d20991d4fba0fcca473e41718fcbf77d.avif";